export * from './queryParser';
export * from './welcomeTitle';
export * from './fetchWrapper';
export * from './cookieYes';
export * from './reviewPurchaseConversion';
export * from './googleAdsAccount';
export * from './pltv';
export * from './ltvCalculator';
export * from './stripeCurrencyAmounts';
export * from './upsellPurchaseQueue';
export * from './formatMoney';
export * from './geoCurrency';
export * from './countryLocalization';

export const getCssSize = (val: string | number = 0): string => {
  if (!isNaN(+val)) return `${val || 0}px`;
  return val.toString();
};

export const removePreloader = () => {
  const pre = document.getElementById('preloader');
  if (pre) {
    pre.style.opacity = '0';
    pre.style.transition = 'opacity 0.2s ease';

    setTimeout(() => {
      pre.remove();
      const styleTag = document.getElementById('preloader-style');
      if (styleTag) styleTag.remove();
      const scriptTag = document.getElementById('preloader-script');
      if (scriptTag) scriptTag.remove();
    }, 200);
  }
};

export const scheduleRemovePreloader = () => {
  const removeWithDelay = () => setTimeout(removePreloader, 1000);
  if (document.readyState === 'complete') {
    removeWithDelay();
  } else {
    window.addEventListener('load', removeWithDelay);
  }
};

export const getRussianDayPlural = (count: number): string => {
  const remainder10 = count % 10;
  const remainder100 = count % 100;

  if (remainder100 >= 11 && remainder100 <= 14) {
    return `${count} дней`;
  }

  if (remainder10 === 1) {
    return `${count} день`;
  } else if (remainder10 >= 2 && remainder10 <= 4) {
    return `${count} дня`;
  } else {
    return `${count} дней`;
  }
};
